export default __webpack_public_path__ + "static/media/single-04-office-inactive.500173c5.webp";